import { CssBaseline, ThemeProvider } from "@mui/material";
import { StyledEngineProvider } from "@mui/material/styles";
import { FC, useEffect } from "react";
import { Toaster } from "react-hot-toast";
import { useLocation, useRoutes } from "react-router-dom";
import routes from "./routes";
import { initGA, trackPageView } from "./services/ga4";
import { useFetch } from "./hooks/useFetch";
import { supportTheme } from "./theme";

const App: FC = () => {
  const location = useLocation();
  const allPages = useRoutes(routes);
  const isAuthenticated = !!localStorage.getItem('user');
  const { data: configData } = useFetch<{ gaMeasurementId: string | null }>({ endpoint: '/config', immediate: isAuthenticated });

  useEffect(() => {
    const gaId = configData?.gaMeasurementId || process.env.REACT_APP_GA_MEASUREMENT_ID;
    if (!gaId) {
      return;
    }

    initGA(gaId);
    trackPageView(location.pathname + location.search);
  }, [configData, location]);

  // App theme
  const appTheme = supportTheme();

  // toaster options
  const toasterOptions = {
    style: {
      fontWeight: 500,
      fontFamily: "'Montserrat', sans-serif",
    },
  };

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={appTheme}>
        <CssBaseline />
        <Toaster toastOptions={toasterOptions} />
        {allPages}
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;
